import { useContext } from 'react';
import clsx from 'clsx';

import SchemaDetailContext, {
  PreviewTab,
} from '@atom/components/schemaDetail/SchemaDetailContext';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './schemaDetailHeader.module.css';

export interface Props {
  view: {
    value: PreviewTab;
    label: string;
    icon: string;
  };
}

const HeaderNavigationButton = ({ view }: Props) => {
  const { previewTab, setPreviewTab } = useContext(SchemaDetailContext);

  const { value, label, icon } = view;

  return (
    <div
      onClick={() => setPreviewTab(value)}
      className={clsx(
        classes.iconContainer,
        previewTab === value && classes.active,
      )}
    >
      <div className={classes.icon}>
        <Icon color={colors.neutral.white} children={icon} />
      </div>
      <div className={classes.buttonLabel}>{label}</div>
    </div>
  );
};

export default HeaderNavigationButton;
